export default "__VITE_ASSET__c0979299__"